import React, { Component } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Row,
    Col
} from "reactstrap";
import { Link } from "react-router-dom";
import { Button, List, ListItem, ListItemText } from "@material-ui/core";

class ViewAttachedFiles extends Component {
    render() {
        const { isOpen, close, qr } = this.props;

        return (
            <Modal isOpen={isOpen}>
                <ModalHeader>View Equipment Documents</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col>
                            {qr.attached_files && (
                                <List>
                                    {qr.attached_files.map(e => {
                                        return (
                                            <Link
                                                to={`pdf-viewer/file_manager/${e.file_id}`}
                                            >
                                                <ListItem>
                                                    <ListItemText
                                                        primary={e.file}
                                                    />
                                                </ListItem>
                                            </Link>
                                        );
                                    })}
                                </List>
                            )}
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button variant="contained" onClick={() => close()}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}
export default ViewAttachedFiles;
